/**
 * 写入 accessToken 到 Cookie（供 img/a 标签访问 /api/file/ 时自动携带）
 */
export const setTokenCookie = (token: string, maxAge = 7200) => {
    // 注意：前端 JS 设置的 Cookie 不能加 HttpOnly（后端 Set-Cookie 才能加）
    // SameSite=Lax 允许同站 GET 请求携带 Cookie（img/a 标签）
    document.cookie = `accessToken=${encodeURIComponent(token)}; path=/; max-age=${maxAge}; SameSite=Lax`;
};

/**
 * 清除 accessToken Cookie
 */
export const clearTokenCookie = () => {
    document.cookie = "accessToken=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT";
};
